import { render, staticRenderFns } from "./DraftCampaigns.vue?vue&type=template&id=32af3ccb&scoped=true"
import script from "./DraftCampaigns.vue?vue&type=script&lang=ts"
export * from "./DraftCampaigns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af3ccb",
  null
  
)

export default component.exports